module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir o arquivo?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirArquivo()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n    \"" + _vm._s(this.descricaoArquivoExclusao) + "\" será excluído após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaArquivos,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui arquivos.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.nome",
      fn: function(props) {
        return [_c('a', {
          attrs: {
            "href": _vm.api_url + '/projetos/' + _vm.idProjeto + '/arquivos/' + props.item.idArquivo
          }
        }, [_c('v-icon', [_vm._v("vertical_align_bottom")]), _vm._v(_vm._s(props.item.nome.trim()) + "\n      ")], 1)]
      }
    }, {
      key: "item.dtInclusao",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInclusao)))]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('v-btn', {
          staticStyle: {
            "margin": "1px"
          },
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.editarArquivo(_vm.idProjeto, props.item.idArquivo)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), (_vm.administrador === true) ? _c('v-btn', {
          staticStyle: {
            "margin": "1px"
          },
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.botaoExcluirArquivo(props.item.idArquivo, props.item.nome.trim())
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaArquivos.length) + " arquivos\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ContatosProjeto",
      "editar": "UploadArquivo",
      "nome_editar": "Adicionar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d36f46a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-arquivos-tabela.vue
// module id = 506
// module chunks = 0